// x-cart.js — добавление в корзину из наших секций (карточки категорий, наборы, допродажа в корзине).
// Повторяет логику product-form.js: событие CartLinesUpdateEvent + /cart/add.js с sections,
// чтобы боковая корзина темы обновилась и открылась сама (auto-open).
import { CartLinesUpdateEvent } from '@shopify/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

export async function xAdd(lines, source) {
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  (source || document.body).dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity || 1 })),
      promise: deferred.promise,
    })
  );
  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map((l) => ({ id: Number(l.id), quantity: l.quantity || 1 })), sections: sectionIds.join(',') }),
    });
    const data = await res.json();
    const cart = await (await fetch(root + 'cart.js')).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'x-cart', sourceId: 'x-cart', itemCount: lines.reduce((a, l) => a + (l.quantity || 1), 0), sections: data.sections, didError: !!data.status },
    });
    return !data.status;
  } catch (e) {
    try { deferred.reject(e); } catch (_) {}
    return false;
  }
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-x-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const ids = String(btn.dataset.xAdd).split(',').filter(Boolean);
  const label = btn.innerHTML;
  btn.disabled = true;
  btn.classList.add('is-loading');
  const ok = await xAdd(ids.map((id) => ({ id, quantity: 1 })), btn);
  btn.classList.remove('is-loading');
  btn.innerHTML = ok ? (btn.dataset.xAdded || 'Added') : 'Try again';
  setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 1800);
});
